import React from 'react';
import { Layout, CheckCircle2, TrendingUp, Shield, Zap } from 'lucide-react';

const LandingPage = ({ onLogin }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col font-sans text-slate-900">
      
      {/* Navigation */}
      <nav className="w-full max-w-6xl mx-auto px-6 py-6 flex justify-between items-center">
        <div className="flex items-center gap-2 font-bold text-xl text-slate-800">
          <div className="bg-blue-600 p-1.5 rounded-lg text-white">
            <Layout size={20} />
          </div>
          Milestone Manager
        </div>
        <button 
          onClick={onLogin}
          className="text-slate-600 hover:text-blue-600 font-medium transition-colors"
        >
          Sign In
        </button>
      </nav>

      {/* Hero Section */}
      <main className="flex-1 flex items-center justify-center px-6 py-12 md:py-20">
        <div className="max-w-4xl w-full grid md:grid-cols-2 gap-12 items-center">
          
          <div className="space-y-8 animate-in slide-in-from-bottom-10 duration-700 fade-in">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold uppercase tracking-wide">
                <Zap size={14} />
                <span>Project Management Simplified</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.1]">
                Track Milestones, <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Master Budgets.
                </span>
              </h1>
              <p className="text-lg text-slate-600 max-w-md leading-relaxed">
                Stay on top of your contract deliverables, manage deadlines, and track financial progress in one intuitive dashboard.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={onLogin}
                className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-4 rounded-xl font-semibold transition-all shadow-lg hover:shadow-blue-200 hover:-translate-y-0.5 active:translate-y-0"
              >
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-5 h-5 brightness-0 invert" alt="" />
                Get Started
              </button>
            </div>

            <div className="pt-4 grid grid-cols-2 gap-y-4 gap-x-8 text-sm text-slate-500">
              <div className="flex items-center gap-2">
                <CheckCircle2 size={18} className="text-emerald-500" />
                <span>Real-time Tracking</span>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp size={18} className="text-blue-500" />
                <span>Budget Analytics</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield size={18} className="text-indigo-500" />
                <span>Secure Data</span>
              </div>
            </div>
          </div>

          {/* Visual / Abstract graphic */}
          <div className="relative hidden md:block h-96 animate-in fade-in zoom-in duration-1000 delay-200">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-100 to-indigo-50 rounded-2xl transform rotate-3 shadow-inner"></div>
            <div className="absolute inset-0 bg-white rounded-2xl shadow-2xl transform -rotate-2 border border-slate-100 p-6 flex flex-col gap-4 overflow-hidden">
              {/* Mock UI Elements */}
              <div className="flex justify-between items-center border-b border-slate-50 pb-4">
                <div className="h-4 w-32 bg-slate-100 rounded"></div>
                <div className="h-8 w-8 bg-blue-50 rounded-full"></div>
              </div>
              <div className="space-y-3">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="flex items-center gap-4 p-3 rounded-lg bg-slate-50/50 border border-slate-50">
                    <div className="w-2 h-2 rounded-full bg-blue-400"></div>
                    <div className="flex-1 h-2 bg-slate-200 rounded w-full"></div>
                    <div className="h-2 w-12 bg-slate-200 rounded"></div>
                  </div>
                ))}
              </div>
              <div className="mt-auto p-4 bg-indigo-50 rounded-xl border border-indigo-100">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-1.5 bg-white rounded-md text-indigo-600 shadow-sm">
                    <TrendingUp size={16} />
                  </div>
                  <div className="h-3 w-20 bg-indigo-200 rounded"></div>
                </div>
                <div className="h-6 w-32 bg-indigo-900/10 rounded"></div>
              </div>
            </div>
          </div>

        </div>
      </main>

      <footer className="py-6 text-center text-slate-400 text-sm">
        © {new Date().getFullYear()} Milestone Manager. All rights reserved.
      </footer>
    </div>
  );
};

export default LandingPage;
